import React, {useState} from 'react'
import {Link} from 'react-router-dom'
import {KTCard, KTCardBody, KTSVG} from '../../../../../_metronic/helpers'
import { TriggersListWrapper } from '../../triggers/triggers-list/TriggersList'
import { MainScrappingWrapper } from './MainScrapping'
import { ScrappingListHeader } from '../scrapping-table/components/header/ScrappingListHeader'
import { ScrappingTable } from '../scrapping-table/table/ScrappingTable'
import { Line, Circle } from 'rc-progress';

interface CrwalTableProps {
  tableLoading: boolean,
  fetchLoading: boolean,
  handletableLoading : (value:boolean) => void,
  setDataHandler : (value:string) => void
}

const CrwalTable: React.FC<CrwalTableProps> = ({tableLoading,handletableLoading,fetchLoading, setDataHandler}) => {
  return (
    <>
      
      <div className='d-flex flex-column flex-center text-center mt-5'>
      <div>
        {tableLoading && (
          <div className='mt-3'>
            <div className='loading__bar'></div>
          </div>
          
        )}
       
      </div>
      
      
        <div className='card card-flush w-lg-950px p-10'>
        <ScrappingListHeader handletableLoading={handletableLoading} setDataHandler={setDataHandler}/>
        <ScrappingTable />
        </div>
      </div>
    </>
  )
}

export {CrwalTable}
